import React from 'react';


class List extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      postID : ''
    }
  }

  render(){

    const { data, onClick } = this.props;

    return (
      <div>
        {data.map( item =>
          <article key={`postid-${item.id}`} >
            <h2 className='title'>
              <a alt={item.title.rendered} data-postid={item.id} onClick={onClick} href={item.link}>{item.title.rendered} </a>
            </h2>
            <a alt={item.title.rendered} data-postid={item.id} onClick={onClick} href={item.link}>{item.link} </a>
            <div className="excerpt">
              <span>{item.date}</span>
              <p className="excerpt">
                {item.excerpt.rendered}
              </p>
            </div>
          </article>
        )}
      </div>
    );
  }

}

export default List;



// WEBPACK FOOTER //
// ./src/components/list.js